import { cx } from '@emotion/css';

import CreateCardButton from './CreateCardButton';
import SidenavList from './SidenavList';
import {
  bodyClassName,
  headerClassName,
  innerClassName,
  sidenavClassName,
  visibleClassName,
} from './styles';

interface Props {
  isMenuVisible?: boolean;
  hideMenu: () => void;
}

const Sidenav = ({ isMenuVisible, hideMenu }: Props) => {
  return (
    <nav
      className={cx(sidenavClassName, { [visibleClassName]: isMenuVisible })}
    >
      <div className={innerClassName}>
        <div className={headerClassName}>
          <CreateCardButton hideMenu={hideMenu} />
        </div>
        <div className={bodyClassName}>
          <SidenavList hideMenu={hideMenu} />
        </div>
      </div>
    </nav>
  );
};

Sidenav.displayName = 'Sidenav';

export default Sidenav;
